import React, {useEffect, useState} from 'react'
import {
  ILicenseTypes,
  LicenseTypesInitValues as initialValues,
} from '../../models/LicenseTypesModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useLocation, useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {useIntl} from 'react-intl'
import {Input3} from '../../../../../../components/Forms/Input'
import AsyncSelect from 'react-select/async'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {colourStyles} from '../../../licenses/components/styles/styles'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const license_typesSchema = Yup.object().shape({
  abbreviate: Yup.string().required('Campo obrigatório'),
  description: Yup.string().required('Campo obrigatório'),
  // renewable: Yup.boolean().required('Campo obrigatório'),
  // telephone: Yup.string().required('Campo obrigatório'),
  //descripton: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().required('Campo obrigatório'),
})

export interface UseOption {
  value: string
  label: string
}

const FormLicenseTypesEdit: React.FC = () => {
  const intl = useIntl()
  const location = useLocation()
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate()
  const [selectedIssueOrgans, setSelectedIssueOrgans] = useState([])
  const {uuid, renewable, expire, description, abbreviate, issue_organ} =
    location.state as ILicenseTypes

  useEffect(() => {
    formik.setFieldValue('uuid', uuid)
    formik.setFieldValue('renewable', renewable)
    formik.setFieldValue('expire', expire)
    formik.setFieldValue('description', description)
    formik.setFieldValue('abbreviate', abbreviate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  // toda vez que a dependência é atualizada, o useEffect é chamado

  const [loading, setLoading] = useState(false)
  const formik = useFormik<ILicenseTypes>({
    initialValues,
    validationSchema: license_typesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.put(API_URL + '/sga/v1/license_types/' + values.uuid, values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'LICENSE_TYPES.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/license_types')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'LICENSE_TYPES.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  function resetInputs() {
    formik.resetForm()
  }

  async function deleteLicense_types(uuid: string) {
    await axios
      .delete(API_URL + '/sga/v1/license_types/' + uuid)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'LICENSE_TYPES.SWAL_DELETE'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/license_types')
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title:
            intl.formatMessage({id: 'LICENSE_TYPES.SWAL_DELETE_ERROR'}) +
            ' erro = ' +
            error.response.data.message,
          confirmButtonColor: '#d33',
          showConfirmButton: true,
          confirmButtonText: intl.formatMessage({id: 'USER.SIGNOUT'}),
        })
      })
  }

  function deleteMsgLicense_types() {
    MySwal.fire({
      title: intl.formatMessage({id: 'COMMON.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (uuid) deleteLicense_types(uuid)
      }
    })
  }

  const loadOptionsIssueOrgans = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getIssueOrgan()
      let organs: any = []
      let options: any = []

      if (issue_organ) console.log('issue_organ_id', issue_organ)

      async function getIssueOrgan() {
        const {data} = await axios.get(API_URL + '/v1/issue_organs/select2')
        let Response = data.results
        console.log('Response select2', Response)

        if (Response) {
          for (let i = 0; i < Response.length; i++) {
            const field: any = {
              value: Response[i].id,
              label: Response[i].name,
            }

            organs.push(field)
            //CONDICIONAL PARA SELECT2 MULTIPLOS
            if (issue_organ) {
              for (let j = 0; j < issue_organ.length; j++) {
                if (parseInt(issue_organ[j].id.toLocaleString()) === Response[i].id) {
                  options.push(field)
                }
              }
            }
          }
        }
        console.log('options', options)
        setSelectedIssueOrgans(options)
      }

      callback(organs)
    }, 1000)
  }

  // os dados do select usuário SGT
  const handleInputChangeIssueOrgans = (event: any) => {
    let inputValue = []
    if (event) {
      for (const element of event) {
        inputValue.push(element.value)
      }
    }
    setSelectedIssueOrgans(event)
    formik.setFieldValue('issue_organ_id', inputValue)
    return {inputValue}
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}

      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'LICENSE_TYPES.EDIT_LICENSE'})}
      </PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row'>
              {/* INICIO ABBREVIATION */}
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'LICENSE_TYPES.INPUT_ABBREVIATION'})}
                  placeholder={intl.formatMessage({id: 'LICENSE_TYPES.INPUT_ABBREVIATION'})}
                  {...formik.getFieldProps('abbreviate')}
                  required
                />
              </div>

              {/* FIM ABBREVIATION */}

              {/* INICIO DESCRIÇÃO ----------------------*/}
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                  placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                  {...formik.getFieldProps('description')}
                  required
                />
              </div>
              {/* FIM DESCRIÇÃO ------------------------------*/}
            </div>

            {/* INICIO ISSUE ORGANS */}
            <div className='row mt-3'>
              <div className='col-lg-12'>
                <label className='form-label fw-bold required'>
                  <span className='required'>
                    {intl.formatMessage({id: 'LICENSES.RESPONSIBLE_ISSUE_ORGAN'})}
                  </span>
                </label>
                <AsyncSelect
                  className='form-control form-control-lg form-control-solid p-0 pl-1'
                  styles={colourStyles}
                  isMulti
                  cacheOptions
                  loadOptions={loadOptionsIssueOrgans}
                  defaultOptions
                  value={selectedIssueOrgans}
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                  }
                  onChange={handleInputChangeIssueOrgans}
                  placeholder={intl.formatMessage({id: 'SELECT.INPUT_RESPONSIBLE_ISSUE_ORGAN'})}
                />
              </div>
            </div>
            {/* FIM ISSUE ORGANS */}

            {/* INICIO RENOVATION */}
            <div className='row mt-2'>
              <div className='d-flex col-lg-12'>
                <label className='col-lg-2 col-form-label fw-bold required'>
                  {intl.formatMessage({id: 'LICENSE_TYPES.RENEWABLE'})}
                </label>
                <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                  <label className='form-check-label'>
                    {intl.formatMessage({id: 'COMMON.NO'})}
                    &nbsp;
                  </label>
                  <input
                    className='form-check-input h-20px w-30px'
                    type='checkbox'
                    id='allowmarketing'
                    checked={formik.values.renewable === true ? true : false}
                    {...formik.getFieldProps('renewable')}
                  />
                  <label className='form-check-label'>
                    {intl.formatMessage({id: 'COMMON.YES'})}
                  </label>
                </div>
                {formik.touched.renewable && formik.errors.renewable && (
                  <div className='fv-plugins-message-container text-danger'>
                    <div className='fv-help-block'>{formik.errors.renewable}</div>
                  </div>
                )}
              </div>
            </div>
            {/* FIM RENOVATION */}

            {/* INICIO EXPIRATION */}
            <div className='row mb-3'>
              <div className='d-flex col-lg-12'>
                <label className='col-lg-2 col-form-label fw-bold required'>
                  {intl.formatMessage({id: 'LICENSES.EXPIRATION_DATE'})}
                </label>
                <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                  <label className='form-check-label'>
                    {intl.formatMessage({id: 'COMMON.NO'})}
                    &nbsp;
                  </label>
                  <input
                    className='form-check-input h-20px w-30px'
                    type='checkbox'
                    id='allowmarketing'
                    checked={formik.values.expire === true ? true : false}
                    {...formik.getFieldProps('expire')}
                  />
                  <label className='form-check-label'>
                    {intl.formatMessage({id: 'COMMON.YES'})}
                  </label>
                </div>
                {formik.touched.expire && formik.errors.expire && (
                  <div className='fv-plugins-message-container text-danger'>
                    <div className='fv-help-block'>{formik.errors.expire}</div>
                  </div>
                )}
              </div>
            </div>
            {/* FIM EXPIRATION */}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.EDIT_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.EDITING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>

              <button
                type='button'
                onClick={deleteMsgLicense_types}
                className='btn btn-sm btn-outline btn-outline-danger btn-active-danger ml-3'
              >
                {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormLicenseTypesEdit}
